/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import Measure from 'react-measure';
import classNames from 'classnames';

import './toolbar.scss';

const SIZES = {
	'small': [0, 950],
	'large': [951, Infinity]
};

class Toolbar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			size: undefined
		};
	}

	render() {
		const { size } = this.state;
		const classes = classNames({
			'explore-vis-toolbar': true,
			'small': size === 'small',
			'large': size === 'large'
		});

		return (
			<Measure
				onResize={(contentRect) => this.onResize(contentRect)}
			>
				{({ measureRef }) =>
					<div className={classes} ref={measureRef}>
						<div className="explore-vis-toolbar__container">
							{this.props.children}
						</div>
					</div>
				}
			</Measure>
		);
	}

	onResize({ entry: { width } = {} } = {}) {
		if (width) {
			const size = Object.keys(SIZES).find((key) => {
				const [ min, max ] = SIZES[key];
				return width >= min && width <= max;
			});

			if (size) {
				this.setState({
					size
				});
				this.props.onResize(size);
			}
		}
	}

}

Toolbar.propTypes = {
	children: PropTypes.any,
	onResize: PropTypes.func
};

Toolbar.defaultProps = {
	children: [],
	onResize: () => {}
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/js/components/toolbar/Toolbar.js